var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper-slide-arrow_btn",class:_vm.class_list,attrs:{"role":"button","aria-label":_vm.is_prev ? 'prev' : 'next'}},[(_vm.is_prev)?_c('chevron-left-icon'):_c('chevron-right-icon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }